import React from "react";

export default function VerifiedSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="153"
      height="74"
      fill="none"
      viewBox="0 0 153 74"
    >
      <circle
        cx="37"
        cy="37"
        r="36.25"
        stroke="#1C64F2"
        strokeWidth="1.5"
      ></circle>
      <rect
        width="128.21"
        height="36.392"
        x="24.79"
        y="19.294"
        fill="#fff"
        rx="18.196"
      ></rect>
      <circle cx="37.211" cy="37.211" r="34.211" fill="#1C64F2"></circle>
      <path
        fill="#fff"
        d="M37.205 34.25l2.846-6.82-2.247-5.005-.581-1.283-.6 1.3L24.8 48.727h5.865l4.395-9.652h-.01l2.156-4.825zM42.192 32.198l-2.825 6.849.012.028h-.024l.01.009-.133.288-2.15 5.213h4.778l.086.206 1.78 3.935h5.886l-7.42-16.528z"
      ></path>
      <path
        fill="#111928"
        d="M78.739 30.935h1.864l1.21 9.12h.033l1.21-9.12h1.696l-1.78 11.757h-2.453l-1.78-11.757zm9.42 0h5.038v1.68h-3.19v3.107h2.535v1.68h-2.536v3.61h3.191v1.68H88.16V30.935zm8.62 0h2.738c.952 0 1.646.224 2.083.672.437.437.655 1.114.655 2.032v.722c0 1.221-.403 1.994-1.209 2.318v.034c.448.134.761.409.94.823.191.414.286.969.286 1.663v2.066c0 .336.011.61.034.823.022.201.078.403.168.604h-1.882a2.677 2.677 0 01-.134-.537 8.155 8.155 0 01-.034-.907v-2.15c0-.538-.089-.913-.268-1.125-.168-.213-.465-.32-.89-.32h-.639v5.04H96.78V30.934zm2.52 5.039c.37 0 .644-.095.823-.286.19-.19.286-.51.286-.957v-.907c0-.425-.079-.733-.236-.924-.145-.19-.38-.285-.705-.285h-.84v3.359h.672zm6.774-5.039h1.848v11.757h-1.848V30.935zm5.751 0h4.888v1.68h-3.04v3.275h2.385v1.68h-2.385v5.122h-1.848V30.935zm8.293 0h1.848v11.757h-1.848V30.935zm5.751 0h5.039v1.68h-3.192v3.107h2.537v1.68h-2.537v3.61h3.192v1.68h-5.039V30.935zm8.621 0h2.822c.918 0 1.606.246 2.066.74.459.492.688 1.214.688 2.166v5.946c0 .951-.229 1.674-.688 2.166-.46.493-1.148.74-2.066.74h-2.822V30.934zm2.788 10.078c.302 0 .532-.09.689-.269.168-.18.252-.47.252-.873v-6.114c0-.403-.084-.694-.252-.873-.157-.18-.387-.27-.689-.27h-.941v8.399h.941z"
      ></path>
    </svg>
  );
}
